import { isFill, FILL_CELL, PAPER } from './strokes';

// Strokes -> pixels, the ONE place it happens. The bots' guess render, the
// flood fill's barrier map and the saved book image all paint through here,
// so a mark that shows on the pad shows in all three - a fill the bot couldn't
// see would be a bot guessing at a different drawing than the humans.
//
// `size` is the pixel size of the square canvas; coordinates are canvas units.

export const paintStrokes = (ctx, strokes, size, { paper = true } = {}) => {
  const scale = size / 1000;
  if (paper) {
    ctx.fillStyle = PAPER;
    ctx.fillRect(0, 0, size, size);
  }
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  for (const stroke of strokes || []) {
    if (isFill(stroke)) {
      ctx.fillStyle = stroke.c || '#1b1b1b';
      for (const [row, x0, len] of stroke.r) {
        // Snapped outward by a hair so adjacent runs never show a seam.
        ctx.fillRect(x0 * FILL_CELL * scale, row * FILL_CELL * scale,
          len * FILL_CELL * scale + 0.5, FILL_CELL * scale + 0.5);
      }
      continue;
    }
    if (!stroke?.p?.length) continue;
    ctx.strokeStyle = stroke.c || '#1b1b1b';
    ctx.lineWidth = Math.max(1, (stroke.w || 16) * scale);
    ctx.beginPath();
    stroke.p.forEach(([x, y], i) => (
      i === 0 ? ctx.moveTo(x * scale, y * scale) : ctx.lineTo(x * scale, y * scale)
    ));
    // A single tap is a dot; without this it draws nothing at all.
    if (stroke.p.length === 1) ctx.lineTo(stroke.p[0][0] * scale, stroke.p[0][1] * scale);
    ctx.stroke();
  }
};
